import styled from 'styled-components'

const Asterix = () => {
  return <StyledA> * </StyledA>
}

export default Asterix

const StyledA = styled.a`
  color: #ff4d4f;
`
